interface ProfileNameFields {
  displayName?: string | null;
  fullName?: string | null;
  firstName?: string | null;
  lastName?: string | null;
}

// The user's real name: their full name or, when they have none, their first
// and last names together. Empty when none of them is set.
const realName = ({ fullName, firstName, lastName }: ProfileNameFields) =>
  fullName?.trim() || [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ');

export interface ProfileNameLines {
  /** Main line: the display name ("Conocido como") or, without it, the real name. */
  primary: string;
  /** Secondary line: the real name, only shown under a display name. */
  secondary: string | null;
}

// Name lines of a profile. `fallback` is used as the main line when the user
// has no name at all.
export const profileNameLines = (fields: ProfileNameFields, fallback: string): ProfileNameLines => {
  const displayName = fields.displayName?.trim();
  const name = realName(fields);

  if (displayName) {
    return { primary: displayName, secondary: name || null };
  }

  return { primary: name || fallback, secondary: null };
};

// Name shown for another user in a single line: the main line of their profile.
export const publicProfileName = (fields: ProfileNameFields) =>
  profileNameLines(fields, 'Usuario').primary;
